'use client';

import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useState } from 'react';
import { SwiperProps } from 'swiper/react';

import { clsx } from 'clsx';
import { Swiper as SwiperApi } from 'swiper/types';

import { WhyUsDataType } from '@screens/Main/model/types/mainPageData';
import { WhyUsSlider } from '@screens/Main/ui/WhyUsSlider/WhyUsSlider';
import { Container } from '@shared/ui/Container';
import { ResponsiveImage } from '@shared/ui/ResponsiveImage';
import { SectionTitle } from '@shared/ui/SectionTitle';
import { HStack } from '@shared/ui/Stack';

import cls from './WhyUs.module.scss';

type WhyUsProps = {
  data: WhyUsDataType;
};

export const WhyUs = ({ data }: WhyUsProps) => {
  const [swiper, setSwiper] = useState<SwiperApi>();
  const [disablePrev, setDisablePrev] = useState(true);
  const [disableNext, setDisableNext] = useState(false);

  const onInit: SwiperProps['onInit'] = (swiper) => {
    setSwiper(swiper);
  };

  const filteredItems = data?.items.filter((el) => el.active);

  const onClickNext = () => {
    swiper?.slideNext();
    setDisablePrev(false);

    if (swiper?.realIndex === filteredItems.length - 1) {
      setDisableNext(true);
    }
  };

  const onClickPrev = () => {
    swiper?.slidePrev();
    setDisableNext(false);

    if (swiper?.realIndex === 0) {
      setDisablePrev(true);
    }
  };

  return (
    <section className={cls.section}>
      <Container>
        <HStack className={cls.titleWrapper}>
          <SectionTitle className={cls.title}>Почему нам доверяют</SectionTitle>
          {filteredItems.length > 1 && (
            <div className={cls.sliderArrowsWrapper}>
              <button
                aria-label={'предыдущий слайд'}
                className={clsx(cls.sliderButtonPrev, { [cls.disable]: disablePrev })}
                onClick={onClickPrev}
              >
                <ChevronLeft />
              </button>
              <button
                aria-label={'следующий слайд'}
                className={clsx(cls.sliderButtonNext, { [cls.disable]: disableNext })}
                onClick={onClickNext}
              >
                <ChevronRight />
              </button>
            </div>
          )}
        </HStack>
        <div className={cls.contentWrapper}>
          <div className={cls.image}>
            {data?.image && data.image?.imageDesktop && (
              <ResponsiveImage
                desktopSrc={data.image.imageDesktop}
                mobileSrc={data.image?.imageAdaptive}
                fill
                alt={'Ванная комната с комплектом мебели'}
              />
            )}
          </div>
          <WhyUsSlider
            items={filteredItems}
            {...{ onInit }}
          />
        </div>
      </Container>
    </section>
  );
};
